import { createContext, useState } from 'react';

interface FooterColorContextType {
    footerColor: string;
    setFooterColor: (color: string) => void;
}

const defaultColor = '#FAFAFA';

const defaultValue: FooterColorContextType = {
    footerColor: defaultColor,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFooterColor: () => {},
};

export const FooterColorContext = createContext<FooterColorContextType>(defaultValue);


export const FooterColorProvider = ({ children }) => {
    const [footerColor, setFooterColor] = useState(defaultColor);

    return (
        <FooterColorContext.Provider value={{ footerColor, setFooterColor }}>
            {children}
        </FooterColorContext.Provider>
    );
};

